import React, { useEffect } from 'react';
import bem from 'utils/bem';
import { Outlet, useLocation } from 'react-router';
import { ScrollRestoration, useSearchParams } from 'react-router-dom';
import { useMobile } from 'utils/media';
import ruMenu from 'components/Menu/menu-ru';
import kzMenu from 'components/Menu/menu-kz';
import Footer from 'components/Footer';
import FrontHeader from 'components/Header/FrontHeader';
import FixedHeader from 'components/Header/FixedHeader';
import MobileFixedHeader from 'components/Header/MobileFixedHeader';
import MobileFrontHeader from 'components/Header/MobileFrontHeader';
import LoginFormModal from 'forms/forms/LoginForm/Modal';
import ResetPasswordFormModal from 'forms/forms/ResetPasswordForm/Modal';
import FeedbackFormModal from 'forms/forms/FeedbackForm/Modal';
import FeedbackWidget from 'components/FeedbackWidget';
import OfficeMapModal from 'components/OfficeMap/Modal';
import OtvetToaster from 'components/OtvetToaster';
import CertificateFormModal from 'forms/forms/CertificateForm/Modal';
import CourseFormModal from 'forms/forms/CourseForm/Modal';
import UpdateBalanceFormModal from 'forms/forms/UpdateBalanceForm/Modal';
import PaymentCardFormModal from 'forms/forms/PaymentCardForm/Modal';
import KZLoginFormModal from 'forms/forms/KZLoginForm/Modal';
import CancelFormModal from 'forms/forms/CancelForm/Modal';
import OrderFormModal from 'forms/forms/OrderForm/Modal';
import TransferFormModal from 'forms/forms/TransferForm/Modal';
import OfficePayOrderFormModal from 'forms/forms/OfficeOrderPayForm/Modal';
import SpecialistOrderFormModal from 'forms/forms/SpecialistOrderForm/Modal';
import OfficePayPurchaseFormModal from 'forms/forms/OfficePurchasePayForm/Modal';
import FinishPaymentModal from 'components/FinishPaymentModal';
import AddressInfoModal from 'components/OrderTeaser/AddressInfoModal';
import CookieConsent from 'components/CookieConsent';
import BannerModal from 'components/Banner/Modal';
import Model from '../../../model';
import './index.sass';

const { block, el } = bem('layout');

const Layout = ({outlet = null}) => {
    const { isMobile } = useMobile();
    const location = useLocation();
    const { pathname, state } = location;
    const isFront = pathname === '/';
    const { openFeedbackForm, reset, openLoginForm } = Model.modal;

    useEffect(() => {
        reset();
    }, [location]);

    useEffect(() => {
        if ( state?.login ) {
            openLoginForm(state.login)
        }
    }, [state]);

    const MobileHeader = isFront ? MobileFrontHeader : MobileFixedHeader;
    const Header = isFront ? FrontHeader : FixedHeader;

    const data = window.isRuDomain ? ruMenu : kzMenu;

    const className = pathname === '/' ? 'front' : pathname.slice(1).split('/').join('--');

    return <div className={ block(className) }>
        <div className={ el('content') }>
            { outlet ? outlet : <Outlet/> }
        </div>
        <Footer/>
        <div id={ 'short-fixed-specialist-teaser' }/>
        { isMobile ?
            <MobileHeader
                menu={ data }
            /> :
            <Header
                menu={ data }
            />
        }
        <FeedbackWidget onClick={ openFeedbackForm }/>
        <CookieConsent />
        <OrderFormModal/>
        <SpecialistOrderFormModal/>
        <LoginFormModal/>
        <ResetPasswordFormModal/>
        <UpdateBalanceFormModal/>
        <FeedbackFormModal/>
        <CertificateFormModal/>
        <CourseFormModal/>
        <PaymentCardFormModal/>
        <CancelFormModal/>
        <TransferFormModal/>
        <OfficeMapModal/>
        <ScrollRestoration/>
        <OtvetToaster/>
        <OfficePayOrderFormModal/>
        <OfficePayPurchaseFormModal/>
        <KZLoginFormModal/>
        <FinishPaymentModal />
        <AddressInfoModal />
        <BannerModal />
    </div>;
};

export default Layout;
